import { useEffect,useState } from 'react';
import { Outlet } from 'react-router-dom';

import useAuth from '../hooks/useAuth';
import useRefreshToken from '../hooks/useRefreshToken';

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, persist } = useAuth();

    useEffect(() => {

        // when refresh with uncheckd Trust this device ==> we try to apply this logic on unmounted Component
        // we we need to trigger if it was mounted or not
        // ! BUT in my case , I didn't had the problem, sou I commented the solution
        //? let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                // get new access token
                // before the required component
                console.log('let get new AT');
                await refresh();
            }
            catch (err) {
                console.error(err);
            }
            finally {
                //? isMounted &&
                setIsLoading(false);
            }
        };
        //* we need to run this only if we do not have access token, not all the time :
        // persist added here AFTER tutorial video
        // Avoids unwanted call to verifyRefreshToken
        !auth?.accessToken
            //?  && persist
            ? verifyRefreshToken() : setIsLoading(false);

        // return () => isMounted = false;
    }, []);

    // just for use to see what hapenning there
    useEffect(() => {
        console.log(`isLoading: ${isLoading}`);
        console.log(`AT: ${JSON.stringify(auth?.accessToken)}`);
        // trigger the isloading reference
    }, [isLoading]);

    return (
        <>
            {
                !persist
                    ? <Outlet />
                    :
                    isLoading
                        ? <p>Loading...</p>
                        : <Outlet />
            }
        </>
    );
};

export default PersistLogin;